/**
 * Itinerary item types.
 *
 * The `id` values are the exact `ItineraryItemType.rawValue` strings the Swift
 * apps write into `itineraryItems.type`. Changing one here doesn't rename a
 * type — it invents a new one the native apps can't decode.
 */
export const ITINERARY_TYPES = [
  { id: 'venueAccess', label: 'Venue Access', showTiming: true, showKey: 'venueAccess' },
  { id: 'loadIn', label: 'Load In', showTiming: true, showKey: 'loadIn' },
  { id: 'soundcheck', label: 'Soundcheck', showTiming: true, showKey: 'soundCheck' },
  { id: 'doors', label: 'Doors Open', showTiming: true, showKey: 'doorsOpen' },
  { id: 'headline', label: 'Headliner Set', showTiming: true, showKey: 'headlinerSetTime' },
  { id: 'packOut', label: 'Pack Out', showTiming: true, showKey: 'packOut' },
  { id: 'flight', label: 'Flight' },
  { id: 'arrival', label: 'Arrival' },
  { id: 'hotel', label: 'Hotel' },
  { id: 'meeting', label: 'Meeting' },
  { id: 'freeTime', label: 'Free Time' },
  { id: 'catering', label: 'Catering' },
  { id: 'travel', label: 'Travel' },
  { id: 'content', label: 'Content' },
  { id: 'merch', label: 'Merchandise' },
  { id: 'lounge', label: 'Lounge' },
  { id: 'custom', label: 'Custom' },
] as const

export type ItineraryTypeId = (typeof ITINERARY_TYPES)[number]['id']

/**
 * The six points in a show day that carry a time, in running order.
 *
 * Mirrors `TimingKeyRepresentable`. The order matters: it's the order the day
 * sheet reads in, and the order the form presents.
 */
export const SHOW_TIMINGS = ITINERARY_TYPES.filter(
  (entry): entry is Extract<(typeof ITINERARY_TYPES)[number], { showTiming: true }> =>
    'showTiming' in entry && entry.showTiming === true,
)

export function typeLabel(id: string): string {
  return ITINERARY_TYPES.find((entry) => entry.id === id)?.label ?? 'Custom'
}

